import { appConfig } from "#web/configs/app";
import { sentryConfig } from "#web/configs/sentry";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: sentryConfig.dsn,
  environment: appConfig.environment,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.browserProfilingIntegration(),
    Sentry.replayIntegration(),
    Sentry.httpClientIntegration(),
  ],
  // this could be reduced in the future but will help us debug issues in the beginning
  tracesSampleRate: 1.0,
});
